import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class RouterService {

  constructor(private router: Router, private route: ActivatedRoute) {

  }

  currentRoute= new BehaviorSubject<any>('');

  isBotMode(): boolean {
    // Use a regular expression to match the pattern more accurately
    const botRoutePattern = /^\/work\/bots(\/.*)?$/;
    return botRoutePattern.test(this.router.url);
  }

  isPlayMode(): boolean {
    if (this.router.url !== '/work') {
      return true;
    }
    return false;
  }

  isFeedbackPage(): boolean {
    if (this.router.url === '/feedback') {
      return true;
    }
    return false;
  }

  isPodcastPage(): boolean {
    if (/^\/podcast-generator(\/.*)?$/.test(this.router.url)) {
      return true;
    }
    return false;
  }

  isExactPodcastPage(): boolean {
    if (this.router.url === '/podcast-generator') {
      return true;
    }
    return false;
  }

  // datalabs methods

  isDatalabs(): boolean {
    if (/^\/datalabs(\/.*)?$/.test(this.router.url)) {
      return true;
    }
    return false;
  }

  isExactDatalabsPage(): boolean {
    if (this.router.url === '/datalabs') {
      return true;
    }
    return false;
  }

  isPromptGenerator(): boolean {
    if (/^\/prompt-generator(\/.*)?$/.test(this.router.url)) {
      return true;
    }
    return false;
  }

  isExactPromptGeneratorPage(): boolean {
    if (this.router.url === '/prompt-generator') {
      return true;
    }
    return false;
  }

  isExactMyPage(page:string): boolean {
    if (this.router.url === page ) {
      return true;
    }
    return false;
  }
}
